module.exports = __webpack_public_path__ + "img/about-map-4.842de163.png";